import React from "react";
import useTokenIdParam from "hooks/useTokenIdParam";
import { Container } from "@chakra-ui/react";
import useFetchMetadata from "hooks/useFetchMetadata";
import TraitsPreviewContainer from "components/TraitsPreviewContainer";
import TraitsBagContainer from "components/TraitsBagContainer";
import TraitsSelectorContainer from "components/TraitsSelectorContainer";
import useTraitSales from "hooks/useTraitSales";
import DressingRoomProvider from "providers/DressingRoomProvider";
import HoneyAmount from "components/HoneyAmount";
import BearSelectorContainer from "components/BearSelectorContainer";

const StoreBearPage: React.FC = () => {
  const tokenId = useTokenIdParam();
  const [bearMetadata, , isLoading] = useFetchMetadata(tokenId);
  const { traitSales, traitSalesMap } = useTraitSales();

  return (
    <Container pt="12" pb="16">
      <DressingRoomProvider
        tokenId={tokenId!}
        initialTraits={bearMetadata?.traits}
        availableTraits={traitSales.map((sale) => sale.tokenId)}
      >
        <BearSelectorContainer basePath="/store" isLoading={isLoading} pb="3" />

        <TraitsPreviewContainer />
        <TraitsSelectorContainer
          renderCardBody={(tokenId) => (
            <HoneyAmount
              fontSize="sm"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
              fontWeight="semibold"
              iconColor="secondary.500"
              amount={traitSalesMap[tokenId].price}
            />
          )}
        />
        <TraitsBagContainer />
      </DressingRoomProvider>
    </Container>
  );
};

export default StoreBearPage;
